import { apiFetch } from './client';

export interface EmailBatch {
  batch_id: string;
  kind: string;
  subject: string;
  sent_at: string;
  total: number;
  sent_count: number;
  failed_count: number;
  blocked_count: number;
}

export interface EmailRecipient {
  id: string;
  to_address: string;
  status: 'sent' | 'failed' | 'blocked';
  reason: string;
  detail?: string;
  body_preview?: string;
  // True when the row has a template_key for a server-registered
  // template. The "View" button on each recipient row is conditional
  // on this — rows from hand-built emails (broadcasts, newsletter,
  // signup confirmation) come back with has_preview=false.
  has_preview: boolean;
  created_at: string;
}

export interface EmailPreview {
  id: string;
  to_address: string;
  status: 'sent' | 'failed' | 'blocked';
  template_key: string;
  subject: string;
  text_body: string;
  html_body: string;
  created_at: string;
}

export interface ListEmailBatchesResponse {
  items: EmailBatch[];
  total: number;
}

export interface ListEmailRecipientsResponse {
  items: EmailRecipient[];
}

interface ListBatchesOpts {
  from?: string;    // RFC3339
  to?: string;      // RFC3339
  q?: string;       // address ILIKE filter
  kind?: string;    // exact kind filter
  limit?: number;
  offset?: number;
}

export async function listEmailBatches(
  token: string | null,
  slug: string,
  opts: ListBatchesOpts = {},
): Promise<ListEmailBatchesResponse> {
  const qs = new URLSearchParams();
  if (opts.from) qs.set('from', opts.from);
  if (opts.to) qs.set('to', opts.to);
  if (opts.q) qs.set('q', opts.q);
  if (opts.kind) qs.set('kind', opts.kind);
  if (opts.limit) qs.set('limit', String(opts.limit));
  if (opts.offset) qs.set('offset', String(opts.offset));
  const query = qs.toString();
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/email-log${query ? `?${query}` : ''}`;
  return apiFetch<ListEmailBatchesResponse>(path, { token });
}

export async function listEmailRecipients(
  token: string | null,
  slug: string,
  batchId: string,
  q?: string,
): Promise<ListEmailRecipientsResponse> {
  const query = q ? `?q=${encodeURIComponent(q)}` : '';
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/email-log/${encodeURIComponent(batchId)}/recipients${query}`;
  return apiFetch<ListEmailRecipientsResponse>(path, { token });
}

export async function getEmailPreview(
  token: string | null,
  slug: string,
  messageId: string,
): Promise<EmailPreview> {
  const path = `/api/v1/organizations/${encodeURIComponent(slug)}/email-log/messages/${encodeURIComponent(messageId)}/preview`;
  return apiFetch<EmailPreview>(path, { token });
}
